import { css } from "@linaria/core"

import AlertFill from "@/icons/svg/alert-fill.svg?react"
import AnnotateLight from "@/icons/svg/annotate-light.svg?react"
import AnnotateMedium from "@/icons/svg/annotate-medium.svg?react"
import AnnotateRegular from "@/icons/svg/annotate-regular.svg?react"
import AnnotateSemibold from "@/icons/svg/annotate-semibold.svg?react"
import ArrowDownLight from "@/icons/svg/arrow-down-light.svg?react"
import ArrowDownMedium from "@/icons/svg/arrow-down-medium.svg?react"
import ArrowDownRegular from "@/icons/svg/arrow-down-regular.svg?react"
import ArrowDownSemibold from "@/icons/svg/arrow-down-semibold.svg?react"
import ArrowLeftLight from "@/icons/svg/arrow-left-light.svg?react"
import ArrowLeftMedium from "@/icons/svg/arrow-left-medium.svg?react"
import ArrowLeftRegular from "@/icons/svg/arrow-left-regular.svg?react"
import ArrowLeftSemibold from "@/icons/svg/arrow-left-semibold.svg?react"
import ArrowRightLight from "@/icons/svg/arrow-right-light.svg?react"
import ArrowRightMedium from "@/icons/svg/arrow-right-medium.svg?react"
import ArrowRightRegular from "@/icons/svg/arrow-right-regular.svg?react"
import ArrowRightSemibold from "@/icons/svg/arrow-right-semibold.svg?react"
import ArrowUpLight from "@/icons/svg/arrow-up-light.svg?react"
import ArrowUpMedium from "@/icons/svg/arrow-up-medium.svg?react"
import ArrowUpRegular from "@/icons/svg/arrow-up-regular.svg?react"
import ArrowUpSemibold from "@/icons/svg/arrow-up-semibold.svg?react"
import AttachLight from "@/icons/svg/attach-light.svg?react"
import AttachMedium from "@/icons/svg/attach-medium.svg?react"
import AttachRegular from "@/icons/svg/attach-regular.svg?react"
import AttachSemibold from "@/icons/svg/attach-semibold.svg?react"
import BranchLight from "@/icons/svg/branch-light.svg?react"
import BranchMedium from "@/icons/svg/branch-medium.svg?react"
import BranchRegular from "@/icons/svg/branch-regular.svg?react"
import BranchSemibold from "@/icons/svg/branch-semibold.svg?react"
import BuildLight from "@/icons/svg/build-light.svg?react"
import BuildMedium from "@/icons/svg/build-medium.svg?react"
import BuildRegular from "@/icons/svg/build-regular.svg?react"
import BuildSemibold from "@/icons/svg/build-semibold.svg?react"
import CheckmarkLight from "@/icons/svg/checkmark-light.svg?react"
import CheckmarkMedium from "@/icons/svg/checkmark-medium.svg?react"
import CheckmarkRegular from "@/icons/svg/checkmark-regular.svg?react"
import CheckmarkSemibold from "@/icons/svg/checkmark-semibold.svg?react"
import ChevronDownLight from "@/icons/svg/chevron-down-light.svg?react"
import ChevronDownMedium from "@/icons/svg/chevron-down-medium.svg?react"
import ChevronDownRegular from "@/icons/svg/chevron-down-regular.svg?react"
import ChevronDownSemibold from "@/icons/svg/chevron-down-semibold.svg?react"
import ChevronLeftLight from "@/icons/svg/chevron-left-light.svg?react"
import ChevronLeftMedium from "@/icons/svg/chevron-left-medium.svg?react"
import ChevronLeftRegular from "@/icons/svg/chevron-left-regular.svg?react"
import ChevronLeftSemibold from "@/icons/svg/chevron-left-semibold.svg?react"
import ChevronRightLight from "@/icons/svg/chevron-right-light.svg?react"
import ChevronRightMedium from "@/icons/svg/chevron-right-medium.svg?react"
import ChevronRightRegular from "@/icons/svg/chevron-right-regular.svg?react"
import ChevronRightSemibold from "@/icons/svg/chevron-right-semibold.svg?react"
import ChevronUpLight from "@/icons/svg/chevron-up-light.svg?react"
import ChevronUpMedium from "@/icons/svg/chevron-up-medium.svg?react"
import ChevronUpRegular from "@/icons/svg/chevron-up-regular.svg?react"
import ChevronUpSemibold from "@/icons/svg/chevron-up-semibold.svg?react"
import ClaudeLogoFill from "@/icons/svg/claude-logo-fill.svg?react"
import ClockLight from "@/icons/svg/clock-light.svg?react"
import ClockMedium from "@/icons/svg/clock-medium.svg?react"
import ClockRegular from "@/icons/svg/clock-regular.svg?react"
import ClockSemibold from "@/icons/svg/clock-semibold.svg?react"
import CloseLight from "@/icons/svg/close-light.svg?react"
import CloseMedium from "@/icons/svg/close-medium.svg?react"
import CloseRegular from "@/icons/svg/close-regular.svg?react"
import CloseSemibold from "@/icons/svg/close-semibold.svg?react"
import CodeFileLight from "@/icons/svg/code-file-light.svg?react"
import CodeFileMedium from "@/icons/svg/code-file-medium.svg?react"
import CodeFileRegular from "@/icons/svg/code-file-regular.svg?react"
import CodeFileSemibold from "@/icons/svg/code-file-semibold.svg?react"
import CodeTextLight from "@/icons/svg/code-text-light.svg?react"
import CodeTextMedium from "@/icons/svg/code-text-medium.svg?react"
import CodeTextRegular from "@/icons/svg/code-text-regular.svg?react"
import CodeTextSemibold from "@/icons/svg/code-text-semibold.svg?react"
import CommitLight from "@/icons/svg/commit-light.svg?react"
import CommitMedium from "@/icons/svg/commit-medium.svg?react"
import CommitRegular from "@/icons/svg/commit-regular.svg?react"
import CommitSemibold from "@/icons/svg/commit-semibold.svg?react"
import CopyLight from "@/icons/svg/copy-light.svg?react"
import CopyMedium from "@/icons/svg/copy-medium.svg?react"
import CopyRegular from "@/icons/svg/copy-regular.svg?react"
import CopySemibold from "@/icons/svg/copy-semibold.svg?react"
import CreateLight from "@/icons/svg/create-light.svg?react"
import CreateMedium from "@/icons/svg/create-medium.svg?react"
import CreateRegular from "@/icons/svg/create-regular.svg?react"
import CreateSemibold from "@/icons/svg/create-semibold.svg?react"
import CreditsLight from "@/icons/svg/credits-light.svg?react"
import CreditsMedium from "@/icons/svg/credits-medium.svg?react"
import CreditsRegular from "@/icons/svg/credits-regular.svg?react"
import CreditsSemibold from "@/icons/svg/credits-semibold.svg?react"
import DeleteLight from "@/icons/svg/delete-light.svg?react"
import DeleteMedium from "@/icons/svg/delete-medium.svg?react"
import DeleteRegular from "@/icons/svg/delete-regular.svg?react"
import DeleteSemibold from "@/icons/svg/delete-semibold.svg?react"
import DeviceLight from "@/icons/svg/device-light.svg?react"
import DeviceMedium from "@/icons/svg/device-medium.svg?react"
import DeviceRegular from "@/icons/svg/device-regular.svg?react"
import DeviceSemibold from "@/icons/svg/device-semibold.svg?react"
import DiscordFill from "@/icons/svg/discord-fill.svg?react"
import DiscordLineLight from "@/icons/svg/discord-line-light.svg?react"
import DiscordLineMedium from "@/icons/svg/discord-line-medium.svg?react"
import DiscordLineRegular from "@/icons/svg/discord-line-regular.svg?react"
import DiscordLineSemibold from "@/icons/svg/discord-line-semibold.svg?react"
import DownloadLight from "@/icons/svg/download-light.svg?react"
import DownloadMedium from "@/icons/svg/download-medium.svg?react"
import DownloadRegular from "@/icons/svg/download-regular.svg?react"
import DownloadSemibold from "@/icons/svg/download-semibold.svg?react"
import DuplicateIdeaLight from "@/icons/svg/duplicate-idea-light.svg?react"
import DuplicateIdeaMedium from "@/icons/svg/duplicate-idea-medium.svg?react"
import DuplicateIdeaRegular from "@/icons/svg/duplicate-idea-regular.svg?react"
import DuplicateIdeaSemibold from "@/icons/svg/duplicate-idea-semibold.svg?react"
import EditLight from "@/icons/svg/edit-light.svg?react"
import EditMedium from "@/icons/svg/edit-medium.svg?react"
import EditRegular from "@/icons/svg/edit-regular.svg?react"
import EditSemibold from "@/icons/svg/edit-semibold.svg?react"
import ErrorFill from "@/icons/svg/error-fill.svg?react"
import ExpandLight from "@/icons/svg/expand-light.svg?react"
import ExpandMedium from "@/icons/svg/expand-medium.svg?react"
import ExpandRegular from "@/icons/svg/expand-regular.svg?react"
import ExpandSemibold from "@/icons/svg/expand-semibold.svg?react"
import FigmaColor from "@/icons/svg/figma-color.svg?react"
import FigmaLight from "@/icons/svg/figma-light.svg?react"
import FigmaMedium from "@/icons/svg/figma-medium.svg?react"
import FigmaRegular from "@/icons/svg/figma-regular.svg?react"
import FigmaSemibold from "@/icons/svg/figma-semibold.svg?react"
import FilePlainLight from "@/icons/svg/file-plain-light.svg?react"
import FilePlainMedium from "@/icons/svg/file-plain-medium.svg?react"
import FilePlainRegular from "@/icons/svg/file-plain-regular.svg?react"
import FilePlainSemibold from "@/icons/svg/file-plain-semibold.svg?react"
import FolderLight from "@/icons/svg/folder-light.svg?react"
import FolderMedium from "@/icons/svg/folder-medium.svg?react"
import FolderRegular from "@/icons/svg/folder-regular.svg?react"
import FolderSemibold from "@/icons/svg/folder-semibold.svg?react"
import FullScreenLight from "@/icons/svg/full-screen-light.svg?react"
import FullScreenMedium from "@/icons/svg/full-screen-medium.svg?react"
import FullScreenRegular from "@/icons/svg/full-screen-regular.svg?react"
import FullScreenSemibold from "@/icons/svg/full-screen-semibold.svg?react"
import GenerateLight from "@/icons/svg/generate-light.svg?react"
import GenerateMedium from "@/icons/svg/generate-medium.svg?react"
import GenerateRegular from "@/icons/svg/generate-regular.svg?react"
import GenerateSemibold from "@/icons/svg/generate-semibold.svg?react"
import GithubFill from "@/icons/svg/github-fill.svg?react"
import HandWaveLight from "@/icons/svg/hand-wave-light.svg?react"
import HandWaveMedium from "@/icons/svg/hand-wave-medium.svg?react"
import HandWaveRegular from "@/icons/svg/hand-wave-regular.svg?react"
import HandWaveSemibold from "@/icons/svg/hand-wave-semibold.svg?react"
import Heart12Gray from "@/icons/svg/heart-12-gray.svg?react"
import Heart20Gray from "@/icons/svg/heart-20-gray.svg?react"
import Heart20Green from "@/icons/svg/heart-20-green.svg?react"
import Heart12Green from "@/icons/svg/heart-20-green.svg?react"
import HeartEmptyColor from "@/icons/svg/heart-empty-color.svg?react"
import HeartFill from "@/icons/svg/heart-fill.svg?react"
import HeartGreenColor from "@/icons/svg/heart-green-color.svg?react"
import HelpLight from "@/icons/svg/help-light.svg?react"
import HelpMedium from "@/icons/svg/help-medium.svg?react"
import HelpRegular from "@/icons/svg/help-regular.svg?react"
import HelpSemibold from "@/icons/svg/help-semibold.svg?react"
import InfoLight from "@/icons/svg/info-light.svg?react"
import InfoMedium from "@/icons/svg/info-medium.svg?react"
import InfoRegular from "@/icons/svg/info-regular.svg?react"
import InfoSemibold from "@/icons/svg/info-semibold.svg?react"
import InviteLight from "@/icons/svg/invite-light.svg?react"
import InviteMedium from "@/icons/svg/invite-medium.svg?react"
import InviteRegular from "@/icons/svg/invite-regular.svg?react"
import InviteSemibold from "@/icons/svg/invite-semibold.svg?react"
import LinkLight from "@/icons/svg/link-light.svg?react"
import LinkMedium from "@/icons/svg/link-medium.svg?react"
import LinkRegular from "@/icons/svg/link-regular.svg?react"
import LinkSemibold from "@/icons/svg/link-semibold.svg?react"
import LockLight from "@/icons/svg/lock-light.svg?react"
import LockMedium from "@/icons/svg/lock-medium.svg?react"
import LockRegular from "@/icons/svg/lock-regular.svg?react"
import LockSemibold from "@/icons/svg/lock-semibold.svg?react"
import LogoutLight from "@/icons/svg/logout-light.svg?react"
import LogoutMedium from "@/icons/svg/logout-medium.svg?react"
import LogoutRegular from "@/icons/svg/logout-regular.svg?react"
import LogoutSemibold from "@/icons/svg/logout-semibold.svg?react"
import MentionLight from "@/icons/svg/mention-light.svg?react"
import MentionMedium from "@/icons/svg/mention-medium.svg?react"
import MentionRegular from "@/icons/svg/mention-regular.svg?react"
import MentionSemibold from "@/icons/svg/mention-semibold.svg?react"
import MergeRequestOpenLight from "@/icons/svg/merge-request-open-light.svg?react"
import MergeRequestOpenMedium from "@/icons/svg/merge-request-open-medium.svg?react"
import MergeRequestOpenRegular from "@/icons/svg/merge-request-open-regular.svg?react"
import MergeRequestOpenSemibold from "@/icons/svg/merge-request-open-semibold.svg?react"
import MoreLight from "@/icons/svg/more-light.svg?react"
import MoreMedium from "@/icons/svg/more-medium.svg?react"
import MoreRegular from "@/icons/svg/more-regular.svg?react"
import MoreSemibold from "@/icons/svg/more-semibold.svg?react"
import OpenInNewTabLight from "@/icons/svg/open-in-new-tab-light.svg?react"
import OpenInNewTabMedium from "@/icons/svg/open-in-new-tab-medium.svg?react"
import OpenInNewTabRegular from "@/icons/svg/open-in-new-tab-regular.svg?react"
import OpenInNewTabSemibold from "@/icons/svg/open-in-new-tab-semibold.svg?react"
import OpenTaskLight from "@/icons/svg/open-task-light.svg?react"
import OpenTaskMedium from "@/icons/svg/open-task-medium.svg?react"
import OpenTaskRegular from "@/icons/svg/open-task-regular.svg?react"
import OpenTaskSemibold from "@/icons/svg/open-task-semibold.svg?react"
import OpenaiLogoFill from "@/icons/svg/openai-logo-fill.svg?react"
import PickerLight from "@/icons/svg/picker-light.svg?react"
import PickerMedium from "@/icons/svg/picker-medium.svg?react"
import PickerRegular from "@/icons/svg/picker-regular.svg?react"
import PickerSemibold from "@/icons/svg/picker-semibold.svg?react"
import PlayFill from "@/icons/svg/play-fill.svg?react"
import ReloadLight from "@/icons/svg/reload-light.svg?react"
import ReloadMedium from "@/icons/svg/reload-medium.svg?react"
import ReloadRegular from "@/icons/svg/reload-regular.svg?react"
import ReloadSemibold from "@/icons/svg/reload-semibold.svg?react"
import RulesLight from "@/icons/svg/rules-light.svg?react"
import RulesMedium from "@/icons/svg/rules-medium.svg?react"
import RulesRegular from "@/icons/svg/rules-regular.svg?react"
import RulesSemibold from "@/icons/svg/rules-semibold.svg?react"
import ScreenshotLight from "@/icons/svg/screenshot-light.svg?react"
import ScreenshotMedium from "@/icons/svg/screenshot-medium.svg?react"
import ScreenshotRegular from "@/icons/svg/screenshot-regular.svg?react"
import ScreenshotSemibold from "@/icons/svg/screenshot-semibold.svg?react"
import SearchLight from "@/icons/svg/search-light.svg?react"
import SearchMedium from "@/icons/svg/search-medium.svg?react"
import SearchRegular from "@/icons/svg/search-regular.svg?react"
import SearchSemibold from "@/icons/svg/search-semibold.svg?react"
import SettingsLight from "@/icons/svg/settings-light.svg?react"
import SettingsMedium from "@/icons/svg/settings-medium.svg?react"
import SettingsRegular from "@/icons/svg/settings-regular.svg?react"
import SettingsSemibold from "@/icons/svg/settings-semibold.svg?react"
import SidebarLight from "@/icons/svg/sidebar-light.svg?react"
import SidebarMedium from "@/icons/svg/sidebar-medium.svg?react"
import SidebarRegular from "@/icons/svg/sidebar-regular.svg?react"
import SidebarSemibold from "@/icons/svg/sidebar-semibold.svg?react"
import SlackColor from "@/icons/svg/slack-color.svg?react"
import SpinnerLight from "@/icons/svg/spinner-light.svg?react"
import SpinnerMedium from "@/icons/svg/spinner-medium.svg?react"
import SpinnerRegular from "@/icons/svg/spinner-regular.svg?react"
import SpinnerSemibold from "@/icons/svg/spinner-semibold.svg?react"
import StarColor from "@/icons/svg/star-color.svg?react"
import StarFill from "@/icons/svg/star-fill.svg?react"
import StopLight from "@/icons/svg/stop-light.svg?react"
import StopMedium from "@/icons/svg/stop-medium.svg?react"
import StopRegular from "@/icons/svg/stop-regular.svg?react"
import StopSemibold from "@/icons/svg/stop-semibold.svg?react"
import SuccessFill from "@/icons/svg/success-fill.svg?react"
import SwitchWorkspaceLight from "@/icons/svg/switch-workspace-light.svg?react"
import SwitchWorkspaceMedium from "@/icons/svg/switch-workspace-medium.svg?react"
import SwitchWorkspaceRegular from "@/icons/svg/switch-workspace-regular.svg?react"
import SwitchWorkspaceSemibold from "@/icons/svg/switch-workspace-semibold.svg?react"
import TerminalLight from "@/icons/svg/terminal-light.svg?react"
import TerminalMedium from "@/icons/svg/terminal-medium.svg?react"
import TerminalRegular from "@/icons/svg/terminal-regular.svg?react"
import TerminalSemibold from "@/icons/svg/terminal-semibold.svg?react"
import TimelineLight from "@/icons/svg/timeline-light.svg?react"
import TimelineMedium from "@/icons/svg/timeline-medium.svg?react"
import TimelineRegular from "@/icons/svg/timeline-regular.svg?react"
import TimelineSemibold from "@/icons/svg/timeline-semibold.svg?react"
import TodoRegular from "@/icons/svg/todo-regular.svg?react"
import TuningLight from "@/icons/svg/tuning-light.svg?react"
import TuningMedium from "@/icons/svg/tuning-medium.svg?react"
import TuningRegular from "@/icons/svg/tuning-regular.svg?react"
import TuningSemibold from "@/icons/svg/tuning-semibold.svg?react"
import UploadLight from "@/icons/svg/upload-light.svg?react"
import UploadMedium from "@/icons/svg/upload-medium.svg?react"
import UploadRegular from "@/icons/svg/upload-regular.svg?react"
import UploadSemibold from "@/icons/svg/upload-semibold.svg?react"
import UserLight from "@/icons/svg/user-light.svg?react"
import UserMedium from "@/icons/svg/user-medium.svg?react"
import UserRegular from "@/icons/svg/user-regular.svg?react"
import UserSemibold from "@/icons/svg/user-semibold.svg?react"
import VoteLight from "@/icons/svg/vote-light.svg?react"
import VoteMedium from "@/icons/svg/vote-medium.svg?react"
import VoteRegular from "@/icons/svg/vote-regular.svg?react"
import VoteSemibold from "@/icons/svg/vote-semibold.svg?react"
import ZoomInLight from "@/icons/svg/zoom-in-light.svg?react"
import ZoomInMedium from "@/icons/svg/zoom-in-medium.svg?react"
import ZoomInRegular from "@/icons/svg/zoom-in-regular.svg?react"
import ZoomInSemibold from "@/icons/svg/zoom-in-semibold.svg?react"
import ZoomOutLight from "@/icons/svg/zoom-out-light.svg?react"
import ZoomOutMedium from "@/icons/svg/zoom-out-medium.svg?react"
import ZoomOutRegular from "@/icons/svg/zoom-out-regular.svg?react"
import ZoomOutSemibold from "@/icons/svg/zoom-out-semibold.svg?react"


export {
  AlertFill,
  AnnotateLight,
  AnnotateMedium,
  AnnotateRegular,
  AnnotateSemibold,
  ArrowDownLight,
  ArrowDownMedium,
  ArrowDownRegular,
  ArrowDownSemibold,
  ArrowLeftLight,
  ArrowLeftMedium,
  ArrowLeftRegular,
  ArrowLeftSemibold,
  ArrowRightLight,
  ArrowRightMedium,
  ArrowRightRegular,
  ArrowRightSemibold,
  ArrowUpLight,
  ArrowUpMedium,
  ArrowUpRegular,
  ArrowUpSemibold,
  AttachLight,
  AttachMedium,
  AttachRegular,
  AttachSemibold,
  BranchLight,
  BranchMedium,
  BranchRegular,
  BranchSemibold,
  BuildLight,
  BuildMedium,
  BuildRegular,
  BuildSemibold,
  CheckmarkLight,
  CheckmarkMedium,
  CheckmarkRegular,
  CheckmarkSemibold,
  ChevronDownLight,
  ChevronDownMedium,
  ChevronDownRegular,
  ChevronDownSemibold,
  ChevronLeftLight,
  ChevronLeftMedium,
  ChevronLeftRegular,
  ChevronLeftSemibold,
  ChevronRightLight,
  ChevronRightMedium,
  ChevronRightRegular,
  ChevronRightSemibold,
  ChevronUpLight,
  ChevronUpMedium,
  ChevronUpRegular,
  ChevronUpSemibold,
  ClaudeLogoFill,
  ClockLight,
  ClockMedium,
  ClockRegular,
  ClockSemibold,
  CloseLight,
  CloseMedium,
  CloseRegular,
  CloseSemibold,
  CodeFileLight,
  CodeFileMedium,
  CodeFileRegular,
  CodeFileSemibold,
  CodeTextLight,
  CodeTextMedium,
  CodeTextRegular,
  CodeTextSemibold,
  CommitLight,
  CommitMedium,
  CommitRegular,
  CommitSemibold,
  CopyLight,
  CopyMedium,
  CopyRegular,
  CopySemibold,
  CreateLight,
  CreateMedium,
  CreateRegular,
  CreateSemibold,
  CreditsLight,
  CreditsMedium,
  CreditsRegular,
  CreditsSemibold,
  DeleteLight,
  DeleteMedium,
  DeleteRegular,
  DeleteSemibold,
  DeviceLight,
  DeviceMedium,
  DeviceRegular,
  DeviceSemibold,
  DiscordFill,
  DiscordLineLight,
  DiscordLineMedium,
  DiscordLineRegular,
  DiscordLineSemibold,
  DownloadLight,
  DownloadMedium,
  DownloadRegular,
  DownloadSemibold,
  DuplicateIdeaLight,
  DuplicateIdeaMedium,
  DuplicateIdeaRegular,
  DuplicateIdeaSemibold,
  EditLight,
  EditMedium,
  EditRegular,
  EditSemibold,
  ErrorFill,
  ExpandLight,
  ExpandMedium,
  ExpandRegular,
  ExpandSemibold,
  FigmaColor,
  FigmaLight,
  FigmaMedium,
  FigmaRegular,
  FigmaSemibold,
  FilePlainLight,
  FilePlainMedium,
  FilePlainRegular,
  FilePlainSemibold,
  FolderLight,
  FolderMedium,
  FolderRegular,
  FolderSemibold,
  FullScreenLight,
  FullScreenMedium,
  FullScreenRegular,
  FullScreenSemibold,
  GenerateLight,
  GenerateMedium,
  GenerateRegular,
  GenerateSemibold,
  GithubFill,
  HandWaveLight,
  HandWaveMedium,
  HandWaveRegular,
  HandWaveSemibold,
  Heart12Gray,
  Heart12Green,
  Heart20Gray,
  Heart20Green,
  HeartEmptyColor,
  HeartFill,
  HeartGreenColor,
  HelpLight,
  HelpMedium,
  HelpRegular,
  HelpSemibold,
  InfoLight,
  InfoMedium,
  InfoRegular,
  InfoSemibold,
  InviteLight,
  InviteMedium,
  InviteRegular,
  InviteSemibold,
  LinkLight,
  LinkMedium,
  LinkRegular,
  LinkSemibold,
  LockLight,
  LockMedium,
  LockRegular,
  LockSemibold,
  LogoutLight,
  LogoutMedium,
  LogoutRegular,
  LogoutSemibold,
  MentionLight,
  MentionMedium,
  MentionRegular,
  MentionSemibold,
  MergeRequestOpenLight,
  MergeRequestOpenMedium,
  MergeRequestOpenRegular,
  MergeRequestOpenSemibold,
  MoreLight,
  MoreMedium,
  MoreRegular,
  MoreSemibold,
  OpenaiLogoFill,
  OpenInNewTabLight,
  OpenInNewTabMedium,
  OpenInNewTabRegular,
  OpenInNewTabSemibold,
  OpenTaskLight,
  OpenTaskMedium,
  OpenTaskRegular,
  OpenTaskSemibold,
  PickerLight,
  PickerMedium,
  PickerRegular,
  PickerSemibold,
  PlayFill,
  ReloadLight,
  ReloadMedium,
  ReloadRegular,
  ReloadSemibold,
  RulesLight,
  RulesMedium,
  RulesRegular,
  RulesSemibold,
  ScreenshotLight,
  ScreenshotMedium,
  ScreenshotRegular,
  ScreenshotSemibold,
  SearchLight,
  SearchMedium,
  SearchRegular,
  SearchSemibold,
  SettingsLight,
  SettingsMedium,
  SettingsRegular,
  SettingsSemibold,
  SidebarLight,
  SidebarMedium,
  SidebarRegular,
  SidebarSemibold,
  SlackColor,
  SpinnerLight,
  SpinnerMedium,
  SpinnerRegular,
  SpinnerSemibold,
  StarColor,
  StarFill,
  StopLight,
  StopMedium,
  StopRegular,
  StopSemibold,
  SuccessFill,
  SwitchWorkspaceLight,
  SwitchWorkspaceMedium,
  SwitchWorkspaceRegular,
  SwitchWorkspaceSemibold,
  TerminalLight,
  TerminalMedium,
  TerminalRegular,
  TerminalSemibold,
  TimelineLight,
  TimelineMedium,
  TimelineRegular,
  TimelineSemibold,
  TodoRegular,
  TuningLight,
  TuningMedium,
  TuningRegular,
  TuningSemibold,
  UploadLight,
  UploadMedium,
  UploadRegular,
  UploadSemibold,
  UserLight,
  UserMedium,
  UserRegular,
  UserSemibold,
  VoteLight,
  VoteMedium,
  VoteRegular,
  VoteSemibold,
  ZoomInLight,
  ZoomInMedium,
  ZoomInRegular,
  ZoomInSemibold,
  ZoomOutLight,
  ZoomOutMedium,
  ZoomOutRegular,
  ZoomOutSemibold
}

export const Icon32 = css`
  && {
    width: 32px;
    height: 32px;
  }
`

export const Icon20 = css`
  && {
    width: 20px;
    height: 20px;
  }
`

export const Icon16 = css`
  && {
    width: 16px;
    height: 16px;
  }
`

export const Icon12 = css`
  && {
    width: 12px;
    height: 12px;
  }
`